import "./BrandWall.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Brandmarquee from "./sections/Brandmarquee";
import Partners from "./sections/Partners";
import MeasurableResults from "./sections/MeasurableResults";
import Collaborations from "./sections/Collaborations";
import FinalCallToAction from "./sections/FinalCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function BrandWallPage() {
  return <div>
      <Header />
      <Hero />
      <Brandmarquee />
      <Partners />
      <MeasurableResults />
      <Collaborations />
      <FinalCallToAction />
      <Footer />
    </div>;
}